var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"bg-rating"},[_c('div',{staticClass:"stars",style:(("width: " + (_vm.rating / 100) + "%"))})]),_vm._v(" "),_c('b',[_vm._v("| "+_vm._s(_vm._f("intToRating")(_vm.rating)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1108bf9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Professionals/Stars.vue
// module id = null
// module chunks = 